module.exports = __webpack_public_path__ + "img/companylogo9.5ee1e4c4.png";